<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin],
  methods: {
    expandUrl: Fandom.expandUrl,
    exists: Fandom.exists,
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL
  },
  computed: {
  },
};

</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" class="mx-3 mx-md-0" stripe-two-col-simple-component>
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container my-3" :style="{'background-color': content.background_color || 'var(--gray-200)'}">
      <div class="row">
        <div
          class="col-12 px-0 bg-cover-center"
          v-if="content.image"
          :class="[`col-lg-${12 - (content.text_width || 4)}`, content.reverse ? 'order-lg-1' : 'order-lg-2']"
          :style="{'background-image': getContentResponsiveImageURL('image'), 'min-height': content.height}"
        ></div>
        <div class="col-12 px-4 px-md-5 py-4 py-md-5" :class="[`col-lg-${content.text_width || 4}`, content.reverse ? 'order-lg-2' : 'order-lg-1']">
          <h4 class="font-weight-bold mb-lg-5" :class="content.title_class" v-if="content.title">{{content.title}}</h4>
          <p :class="content.description_class" class="mb-4 mb-lg-5" v-if="content.description" v-html="content.description"></p>
          <evaluation-tool-trigger
            class="m-2"
            v-if="content.evaluation_tool" 
            :text="content.evaluation_tool.button_text"
            :content="getContent(content.evaluation_tool.content)"
            :btnClass="getPrimaryButtonClass(content.evaluation_tool.button_class, content.theme)"
          ></evaluation-tool-trigger>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[stripe-two-col-simple-component] {

  & > div {
    border-radius: 6px;
  }

  .bg-cover-center {
    padding-bottom: 30%;
  }

  .order-lg-1.bg-cover-center {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .order-lg-2.bg-cover-center {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  @include media-breakpoint-down(md) {
    .order-lg-1.bg-cover-center, .order-lg-2.bg-cover-center {
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .bg-cover-center {
      padding-bottom: 50%;
    }
  }

}
</style>